import { proxy } from 'valtio';
export const weng888_store = proxy({
    power: 'none',
    trendState: 0,
});
